import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/turnos`;
const logRequest = (action, url) =>
  logApiContext(`turnoService:${action}`, { url, API_URL });
const logInfo = (label, data) => {
  try {
    console.info(label, data);
  } catch (e) {
    /* noop */
  }
};

export const getTurnosByDrivers = async (driverIds, bossId, { startDate, endDate } = {}) => {
  try {
    if (!Array.isArray(driverIds) || driverIds.length === 0) {
      throw new Error("Debes pasar un array de driverIds");
    }

    const url = new URL(`${API_URL}/by-drivers`);
    if (bossId) url.searchParams.set("bossId", bossId);
    if (startDate) url.searchParams.set("startDate", startDate);
    if (endDate) url.searchParams.set("endDate", endDate);

    logRequest("getTurnosByDrivers", url.toString());

    const response = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ driverIds }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al obtener turnos por drivers");
    }

    const { closures } = await response.json();
    return closures;
  } catch (error) {
    console.error("Error al obtener turnos por drivers:", {
      message: error?.message,
      code: error?.code,
      stack: error?.stack,
    });
    throw error;
  }
};

export const getMisTurnos = async ({ driverId, userId, startDate, endDate } = {}) => {
  const storedUser = (() => {
    try {
      const saved = localStorage.getItem("userData");
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  })();

  const effectiveDriverId = driverId || storedUser.driverId;
  const effectiveUserId = userId || storedUser.userId;

  const url = new URL(API_URL);
  if (effectiveDriverId) url.searchParams.set("driverId", effectiveDriverId);
  if (effectiveUserId) url.searchParams.set("userId", effectiveUserId);
  if (startDate) url.searchParams.set("startDate", startDate);
  if (endDate) url.searchParams.set("endDate", endDate);

  logRequest("getMisTurnos", url.toString());

  const res = await fetch(url.toString(), {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (!res.ok) {
    const text = await res.text();
    console.error("Error getMisTurnos response", {
      status: res.status,
      statusText: res.statusText,
      body: text,
    });
    throw new Error(text || "Error al obtener turnos");
  }
  return res.json();
};

export const getTurnoDetalle = async (id) => {
  const url = `${API_URL}/${id}`;
  logRequest("getTurnoDetalle", url);
  logInfo("[WEB][getTurnoDetalle] GET", url);
  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "No se pudo cargar el detalle del turno");
  }
  return res.json();
};

export const updateTurnoById = async (id, payload) => {
  const url = `${API_URL}/${id}`;
  logRequest("updateTurnoById", url);
  logInfo("[WEB][updateTurnoById] PUT", { url, payload });
  const res = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "No se pudo actualizar el turno");
  }
  return res.json();
};

export const deleteTurnoById = async (id) => {
  const url = `${API_URL}/${id}`;
  logRequest("deleteTurnoById", url);
  logInfo("[WEB][deleteTurnoById] DELETE", url);
  const res = await fetch(url, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "No se pudo eliminar el turno");
  }
  return res.json();
};

export const getTurnosSummary = async ({ driverIds = [], startDate, endDate, liquidado = false } = {}) => {
  const url = `${API_URL}/summary`;
  logRequest("getTurnosSummary", url);
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      driverIds,
      startDate,
      endDate,
      liquidado,
    }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "No se pudo cargar el resumen de turnos");
  }
  return res.json();
};

export const marcarTurnosComoLiquidados = async (turnoIds = []) => {
  // Deprecated: se mantiene para compatibilidad, pero usa liquidaciones.
  return Promise.reject(new Error("Usa crearLiquidacionDesdeTurnos para liquidar hojas"));
};

export const getTurnosAnalytics = async ({ startDate, endDate, interval } = {}) => {
  const url = new URL(`${API_URL}/analytics`);
  if (startDate) url.searchParams.set("startDate", startDate);
  if (endDate) url.searchParams.set("endDate", endDate);
  if (interval) url.searchParams.set("interval", interval);

  logRequest("getTurnosAnalytics", url.toString());

  const res = await fetch(url.toString(), {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Error al obtener analíticas");
  }
  return res.json();
};

export const resolveTurnoCredit = async (id, source = "manual", value) => {
  const url = `${API_URL}/${id}/resolve-credit`;
  logRequest("resolveTurnoCredit", url);
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ source, value }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "No se pudo resolver el crédito");
  }
  return res.json();
};
